module.exports = __webpack_public_path__ + "c55723e666749394335e7544124d26da.png";